import pickBy from 'utils/pickBy';

import convertTextSpecToPolotno from './convertTextSpecToPolotno.js';
import getPlaceholderSpec from '../placeholder/getPlaceholderSpec.js';

/**
 * Set the Polotno text element style in the Polotno store.
 * @param {object} element Polotno text element
 * @param {object} style Parabo page style data
 * @param {string} styleName Parabo style name
 * @returns {undefined}
 */
const setTextStyle = (element, style, styleName) => {
  const { custom } = element;
  // Convert the text style to Polotno text element properties.
  // TODO Allow other values, like position to be styled.
  const styleSpec = getPlaceholderSpec(style);

  // update fontSize only when user didn't change it by himself
  let updateFontSize = false;
  if (element.fontSize === custom.style.fontSize) {
    updateFontSize = true;
  }

  const props = {
    ...convertTextSpecToPolotno(styleSpec),
    custom: { ...custom, style, styleName },
  };

  if (!updateFontSize) {
    props.fontSize = undefined;
  }

  // Set only defined properties.
  // Undefined property in style means "don't change it" not "use the defaults".
  const definedProps = pickBy(props, value => value != null);
  element.set(definedProps);
};

export default setTextStyle;
